export enum TRANSACTION_STATUS {
  EXCEPTION = 'EXCEPTION',
  ISSUED = 'ISSUED',
  PAID = 'PAID',
  RETURNED = 'RETURNED',
  STOP_PAYMENT = 'STOP_PAYMENT',
  VOID = 'VOID',
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}

export enum TRANSACTION_STATUS_LABEL {
  EXCEPTION = 'Exception',
  ISSUED = 'Issued',
  OUTSTANDING = 'Outstanding',
  PAID = 'Paid',
  RETURNED = 'Returned',
  STOP_PAYMENT = 'Stop Payment',
  VOID = 'Void',
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}
